import { type LanguageKey } from "@/shared/common/enums";
import { DropdownIndicator, DropdownIndicatorLight } from "@/shared/components";
import { useAppDispatch, useAppSelector, useMediaQuery } from "@/shared/hooks";
import { changeLanguage } from "@/shared/state/language";
import { ReactSelect as Select } from "@ab.uitools/ui-library/components/ReactSelect";

import { LanguageSelectOption } from "./LanguageSelectOption";
import { LanguageSelectSingleValue } from "./LanguageSelectSingleValue";
import { languagesOptions } from "./languagesOptions";

interface Props {
  isLightIcon?: boolean;
}

export const LanguageSelect = ({ isLightIcon }: Props) => {
  const dispatch = useAppDispatch();
  const isDesktop = useMediaQuery();
  const current = useAppSelector((state) => state.language.current);
  const isChanging = useAppSelector((state) => state.language.isChanging);

  return (
    <div className="select--language">
      <Select
        options={languagesOptions}
        size="small"
        selectedValue={current}
        setSelectedValue={(lang) => {
          if (lang) {
            dispatch(changeLanguage(lang as LanguageKey));
          }
        }}
        isDisabled={isChanging}
        isSearchable={false}
        menuPlacement={isDesktop ? "bottom" : "top"}
        components={{
          Option: LanguageSelectOption,
          DropdownIndicator: isLightIcon ? DropdownIndicatorLight : DropdownIndicator,
          SingleValue: LanguageSelectSingleValue,
        }}
      />
    </div>
  );
};
